import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/c/$orgId/$portalId/settings')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/c/$orgId/$portalId/settings"!</div>
}
